import type {
    SignalEventDto,
    SignalEventWithLink,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import type { MouseEvent, ReactElement } from "react";

import type { SignalEventItemProps } from "../SignalEventItem/SignalEventItem";
import { StyledSignalEventItem, StyledInnerWrapper, StyledEventLinkIcon } from "./styles";

type Props = Omit<SignalEventItemProps, "signalEvent"> & {
    children: ReactElement;
    signalEvent: Readonly<SignalEventWithLink>;
    onLinkClick(signalEvent: SignalEventDto): void;
};

const SignalEventItemLink = (props: Props) => {
    const { children, signalEvent, onLinkClick } = props;

    const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        onLinkClick(signalEvent);
    };

    return (
        <a
            href={signalEvent.url}
            target="_blank"
            rel="noreferrer"
            onClick={handleLinkClick}
        >
            <StyledSignalEventItem signalEvent={signalEvent}>
                <StyledInnerWrapper>
                    {children}
                    <StyledEventLinkIcon
                        iconName="open-new-window"
                        size="xs"
                    />
                </StyledInnerWrapper>
            </StyledSignalEventItem>
        </a>
    );
};

export default SignalEventItemLink;
